// extracted by mini-css-extract-plugin
module.exports = {"apply-btn":"ApplyButton_apply-btn__DHjcX","apply-btn-icon":"ApplyButton_apply-btn-icon__owIAj"};